import { TypeCurveScenarioForm } from '../type-curve-scenario-form/type-curve-scenario-form';

export const NewTypeCurveScenarioPage = () => {
  return <TypeCurveScenarioForm />;
};
